var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeartbeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.fill
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.414 5.027a4.076 4.076 0 00-5.989 3.598c0 .11.003.22.01.329a.8.8 0 01-1.598.09 7.445 7.445 0 01-.012-.42A5.676 5.676 0 0112 5.167a5.69 5.69 0 011.834-1.552 5.676 5.676 0 018.341 5.01c0 3.557-2.586 6.67-4.952 8.799a30.414 30.414 0 01-4.8 3.506l-.023.014-.006.003-.002.001s-.001.001-.392-.697l.39.698a.8.8 0 01-.781 0l-.004-.002-.01-.006-.036-.02a15.483 15.483 0 01-.61-.368 30.86 30.86 0 01-1.632-1.094c-1.308-.939-2.987-2.292-4.42-3.931A.8.8 0 116.1 14.474c1.323 1.513 2.895 2.785 4.148 3.683A29.233 29.233 0 0012 19.321a28.797 28.797 0 004.152-3.087c2.322-2.09 4.423-4.79 4.423-7.609a4.076 4.076 0 00-7.837-1.57.8.8 0 01-1.476 0 4.076 4.076 0 00-1.848-2.028z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.916 9.306a.8.8 0 00-1.332 0L6.322 11.2H3a.8.8 0 000 1.6h3.75a.8.8 0 00.666-.356l.834-1.252 2.334 3.502a.8.8 0 001.332 0l1.262-1.894H15a.8.8 0 000-1.6h-2.25a.8.8 0 00-.666.356l-.834 1.252z"
  }))));
}

export default SvgHeartbeat;